import React, { useState, useContext, useRef, useEffect } from "react";
import "../Styles.css";
import "../../common/fileUploads/uploadsStyles.css";
import "../../../ui-styles/centerBlock/centerBlock.css";
import "../../../ui-styles/buttons/ButtonTxt.css";
import "../../../ui-styles/cropper/imagecrop.css";
import "../../../ui-styles/bottomSlider/BottomDetailsSlide.css";
import "../../common/bookAppointment/BookAppointments.css";
import "../../doctor/doctorSettings/doctorSettings.css";
import { LangCtx, CustomCtx } from "../../../lib/context";
import { API } from "aws-amplify";
// import config from "../../../config.json";
import { getDomainDetials, updateDomainDetails, deleteLogo } from "../../../actions/users";
import { toast } from "react-toastify";
import Loader from "../../../lib/ui/loader/Loader";
// import ImageCropper from "../../common/imagecropper/imagecrop";

import Demo from "../../common/imagecropper/easycropper";
import { scan } from "../../../actions/appointment";

const UploadLogo = (props) => {
    // const [trtgt] = useState(null);
    const { l } = useContext(LangCtx);
    const { custom, setCustom } = useContext(CustomCtx);
    const [loading, setLoading] = useState(false);
    const [logo, setLogo] = useState("");

    const [openCrop, setOpenCrop] = useState(false);
    const [imageToCrop, setImageToCrop] = useState(undefined);

    // const [selectedFile, setSelectedFile] = useState(null);

    const [fname, setFname] = useState("");

    // const closeImageCrop = () => {
    //     setImageToCrop(null);
    //     // setSelectedFile(null);
    // };

    const cancelCrop = () => {
        setOpenCrop(false);
        setImageToCrop(undefined);
        // setSelectedFile(null);
    };

    const s_ref = useRef(null);

    const uploadCropped = async (file) => {
        try {
            setLoading(true);
            let filename = fname; //new Date().valueOf() + file.name;

            filename = "consult-logos/" + filename;

            // code for aws s3 bucket
            // Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_CognitoRegion });
            // Storage.put(filename, file, { contentType: file.type, customPrefix: { public: "" } }).then((result) => {
            //     setLoading(false);
            //     const body = {
            //         logo: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_CognitoRegion}.amazonaws.com/${result.key}`,
            //     };
            //     handleSave(body);
            // });

            const formData = new FormData();
            formData.append("file", file);

            let params = {
                bucket: process.env.REACT_APP_s3,
                fileName: filename,
                region: process.env.REACT_APP_s3Region
            }

            let s3UploadRes = await scan(formData, params);


            if (s3UploadRes && s3UploadRes.status) {
                s3UploadRes = s3UploadRes.data
                setLoading(false);
                const body = {
                    logo: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/${s3UploadRes.key}`,
                };
                handleSave(body);
            } else {
                console.log("s3UploadRes.........:)", s3UploadRes)
                toast.error(s3UploadRes.error, {
                    position: toast.POSITION.TOP_RIGHT,
                })
            }

        } catch (e) {
            setLoading(false);
            console.log("Error", e);
        }
    };

    const handleEdit = (id) => {
        switch (id) {
            case "log":
                s_ref.current.click();
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        setLoading(true);
        getDetails();
    }, [custom.logo]);

    const getDetails = () => {
        getDomainDetials(custom.subDomain)
            .then((res) => {
                setLoading(false);
                if (res.status) {
                    if (res.data != null) {
                        setLogo(res.data[0].logo);
                    }
                }
            })
            .catch((err) => {
                if(API.isCancel(err)) {
                    console.log("API is canceled................");
                } else {
                    setLoading(false);
                }
                console.log("err ==== ", err);
            });
    };

    const handleSave = (data) => {
        try {
            setLoading(true);
            updateDomainDetails(custom.subDomain, data)
                .then((res) => {
                    setLoading(false);
                    if (res.status) {
                        toast.success("Logo saved successfully", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        setCustom((prev) => {
                            return { ...prev, logo: res?.data?.logo };
                        });
                    }
                })
                .catch((err) => {
                    setLoading(false);
                });
        } catch (e) {
            setLoading(false);
            toast.error("Failed to upload logo!", {
                position: toast.POSITION.TOP_RIGHT,
            });
            console.log("Error", e);
        }
    };

    const handleUploadFile = async (e) => {
        if (e.target.files.length > 0) {
            setOpenCrop(1);
            const acceptedTypes = ["image/gif", "image/jpeg", "image/jpg", "image/png", "image/avif"];
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (i) => {
                var _img = new Image();
                _img.src = i.target.result;
                _img.onload = async () => {
                    let width = _img.width;
                    let height = _img.height;

                    if (file && acceptedTypes.includes(file["type"]) && file.size / (1024 * 1024) < 15) {
                        if (width > 260 && height > 80) {
                            let filename = new Date().valueOf() + file.name;

                            filename = "consult-logos/" + filename;

                            setFname(filename);

                            // console.log("------------------------err");

                            setImageToCrop(_img);
                            return;
                        }
                        try {
                            setLoading(true);
                            let filename = new Date().valueOf() + file.name;

                            filename = "consult-logos/" + filename;

                            // Storage.configure({ bucket: process.env.REACT_APP_s3, region: process.env.REACT_APP_CognitoRegion });
                            // Storage.put(filename, file, { contentType: file.type, customPrefix: { public: "" } }).then((result) => {
                            //     setLoading(false);
                            //     const body = {
                            //         logo: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_CognitoRegion}.amazonaws.com/${result.key}`,
                            //     };
                            //     handleSave(body);
                            // });
                            const formData = new FormData();
                            formData.append("file", file);
                
                            let params = {
                                bucket: process.env.REACT_APP_s3,
                                fileName: filename,
                                region: process.env.REACT_APP_s3Region
                            }
                
                            let s3UploadRes = await scan(formData, params);
                
                
                            // console.log("s3UploadRes", s3UploadRes);
                            if (s3UploadRes && s3UploadRes.status) {
                                s3UploadRes = s3UploadRes.data
                                setLoading(false);
                                const body = {
                                    logo: `https://${process.env.REACT_APP_s3}.s3-${process.env.REACT_APP_s3Region}.amazonaws.com/${s3UploadRes.key}`,
                                };
                                handleSave(body);
                                // console.log("...........:)", JSON.stringify(body, null, 2))
                            } else {
                                console.log("s3UploadRes.........:)", s3UploadRes)
                                toast.error(s3UploadRes.error, {
                                    position: toast.POSITION.TOP_RIGHT,
                                })
                            }
                            setLoading(false);
                        } catch (e) {
                            setLoading(false);
                            console.log("Error", e);
                        }
                    } else {
                        toast.error("Please upload image with size of below 15 MB.", {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                };
            };
        }
    };

    const deletelogo = () => {
        setLoading(true);

        let body = {
            subdomain: custom.subDomain,
        };
        deleteLogo(body)
            .then((res) => {
                if (res.status) {
                    setLogo(null);
                    setLoading(false);
                    setLogo(null);

                    setCustom((prev) => {
                        return { ...prev, logo: process.env.REACT_APP_logo };
                    });
                    toast.success("Logo Deleted Successfully", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else {
                    // console.log(logo);
                    setLoading(false);
                }
            })
            .catch((error) => {
                setLoading(false);
                console.log("error ==== ", error);
                toast.error(error?.response?.data?.error, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    };

    return (
        <div className="centerBlockContainer">
            <div className="centerBodyBlock pos-rel">
                {loading ? (
                    <Loader />
                ) : (
                    <div className="colBlock">
                        <div className="">
                            <p className="pTxt txtCenter">{l.upload_logo_desc}</p>
                            {!logo ? (
                                <>
                                    <div className="uploadHeadBox">
                                        <input
                                            name="log"
                                            className="uploadInput"
                                            type="file"
                                            id="log"
                                            ref={s_ref}
                                            onChange={handleUploadFile}
                                        />
                                        <div className="uploadIconBox">
                                            <img src="/images/icons/upload.png" className="invertGray" alt="icon" />
                                        </div>
                                        <label htmlFor="log">{l.upload_logo}</label>
                                        <div className="uploadBlockInnerSize">
                                            <span className="uploadBoxSize">260 </span>
                                            <small>&nbsp;X&nbsp;</small>
                                            <span className="uploadBoxSize">80</span>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className="uploadedImgLeft mrgTop16">
                                        <div className="uploadedImgThumbnail uploadedHdrThumbnail">
                                            <div className="uploadedImgContainer">
                                                <img src={logo} alt="banner" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="uploadedImgAction mrgTop16">
                                        <input
                                            name="log"
                                            ref={s_ref}
                                            className="uploadInput"
                                            type="file"
                                            id="log"
                                            hidden
                                            onChange={handleUploadFile}
                                        />
                                        <div className="btnTxtGroup flxEnd">
                                            <button className="btnTxt primary sm" onClick={deletelogo}>
                                                <img src="/images/icons/delete-outline.png" alt="icon" className="invertPrimary" />
                                                <span>{l.delete}</span>
                                            </button>
                                            <button
                                                className="btnTxt primary sm"
                                                onClick={(e) => {
                                                    handleEdit("log");
                                                }}
                                            >
                                                <img src="/images/icons/edit-outline.png" alt="icon" className="invertPrimary" />
                                                <span>{l.update}</span>
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {openCrop && imageToCrop && (
                <div className={imageToCrop ? "btmDtlSlider visible" : "btmDtlSlider"}>
                    <div className="cropperPaper">
                        <Demo
                            cancelCrop={cancelCrop}
                            cropRatio={16 / 9}
                            target={"logo"}
                            imageToCrop={imageToCrop.src}
                            onImageCropped={(croppedImage) => uploadCropped(croppedImage)}
                        ></Demo>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UploadLogo;